import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import DE_LOGO from "../../src/countries/Deutschland.png";
import PT_LOGO from "../../src/countries/Portugal.png";
import FR_LOGO from "../../src/countries/France.png";
import IT_LOGO from "../../src/countries/Italia.png";
import NL_LOGO from "../../src/countries/Netherlands.png";
import ARABIC_LOGO from "../../src/countries/Arabic.png";
import EN_LOGO from "../../src/countries/English.png";
import UA_LOGO from "../../src/countries/Ukraine.png";
import TR_LOGO from "../../src/countries/Turkey.png";
import classNames from "classnames";
import {initLanguage, getAvailableLanguages} from "../../src/state/store";

const languages = [
    {
        code: "pt",
        name: "Portuguese",
        avatar: PT_LOGO,
    },
    {
        code: "fr",
        name: "French",
        avatar: FR_LOGO,
    },
    {
        code: "it",
        name: "Italian",
        avatar: IT_LOGO,
    },
    {
        code: "nl",
        name: "Dutch",
        avatar: NL_LOGO,
    },
    {
        code: "de",
        name: "German",
        avatar: DE_LOGO,
    },
    {
        code: "en",
        name: "English",
        avatar: EN_LOGO,
    },
    {
        code: "tr",
        name: "Turkish",
        avatar: TR_LOGO,
    },
    {
        code: "ar",
        name: "Arabic",
        avatar: ARABIC_LOGO,
    },
    {
        code: "ua",
        name: "Ukrainian",
        avatar: UA_LOGO,
    },
];

export default function LanguageSwitcher() {
    const {t} = useTranslation();
    const {i18n} = useTranslation();
    const [selectedLanguage, setSelectedLanguage] = useState(languages[0]);
    const [availableLanguages, setAvailableLanguages] = useState([]);

    useEffect(() => {
        initLanguage();
        const availableLangs = getAvailableLanguages();
        setAvailableLanguages(availableLangs);

        const storedLanguage = localStorage.getItem("i18nextLng") || "de";
        const language = languages.find((lang) => lang.code === storedLanguage) || languages[0];

        setSelectedLanguage(language);

        if (i18n.language !== storedLanguage) {
            i18n.changeLanguage(storedLanguage);
        }
    }, [i18n]);

    const handleOnChange = (e) => {
        setSelectedLanguage(e);
        i18n.changeLanguage(e.code);
    };

    return (
        <div className="text-center space-y-4">
            <span className="font-medium">
                {t('Select Language')}
            </span>
            <div className="flex justify-between items-center gap-6 md:gap-10">
                { languages.filter(language => Object.values(availableLanguages).includes(language.code)).map((language) => (
                    <div key={language.code}
                         className={classNames({
                             "flex items-center cursor-pointer": true,
                             "border-2 border-cal-primary-celadon-green-00B5B1 rounded-full": selectedLanguage.code === language.code,
                         })}
                         onClick={() => handleOnChange(language)}>
                        <img src={language.avatar} alt={language.name} className="w-8 h-8 rounded-full" />
                    </div>
                ))}
            </div>
        </div>
    );
}
